import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { enums } from '../../helpers';
import { Form } from 'semantic-ui-react';

export default class BankDetailsComponent extends Component {
  static propTypes = {
    entity: PropTypes.string,
    refundMethod: PropTypes.string,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    initialValues: PropTypes.obj,
    readOnly: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      ...(enums.entityToRefundMethod[this.props.entity][this.props.refundMethod] ? enums.entityToRefundMethod[this.props.entity][this.props.refundMethod].reduce((acc, curr) => ({
        ...acc,
        [curr]: this.props.initialValues && this.props.initialValues[curr] ? this.props.initialValues[curr] : null
      }), {}) : {}),
      errors: {}
    }
  }

  onFieldChange = (field) => (e, { value }) => this.setState({ [field]: value })

  render() {
    return (
      <div>
        <Form className="TicketContent" size='mini'>
            <div className="former-group">
            {enums.entityToRefundMethodRender[this.props.entity][this.props.refundMethod].map(field => <Form.Input
              label={field.label}
              required={!this.props.readOnly}
              loading={this.props.loading}
              value={this.state[field.key]}
              onChange={(e, {value}) => {
                this.onFieldChange(field.key)(e, { value });
                this.props.onFieldChange(field.key)(e, { value });
              }}
              error={this.props.errors && this.props.errors[`${this.props.prefix}${field.key}`]}
              readOnly={this.props.readOnly}              
            />)}
            </div>
        </Form>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BankDetailsFormComponent/BankDetailsForm.js